export enum AdditionalOptionControl {
  Checkbox = 'checkbox',
  Dropdown = 'dropdown',
  Radio = 'radio',
  PopUp = 'popup',
}
